import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const TVIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M3.5 16.75V15.25C3.0875 15.25 2.73438 15.1031 2.44062 14.8094C2.14687 14.5156 2 14.1625 2 13.75V5.5C2 5.0875 2.14687 4.73438 2.44062 4.44062C2.73438 4.14687 3.0875 4 3.5 4H15.5C15.9125 4 16.2656 4.14687 16.5594 4.44062C16.8531 4.73438 17 5.0875 17 5.5V13.75C17 14.1625 16.8531 14.5156 16.5594 14.8094C16.2656 15.1031 15.9125 15.25 15.5 15.25V16.75H14.75L14.2625 15.25H4.75625L4.25 16.75H3.5ZM3.5 13.75H15.5V5.5H3.5V13.75Z"
      fill="#ffffff"
    />
    <path d="M11.5 2L9 4.5L5.5 0.5" stroke="#ffffff" strokeLinecap="round" />
    <path
      d="M14.2844 8.08442C14.1406 8.22817 13.9625 8.30005 13.75 8.30005C13.5375 8.30005 13.3594 8.22817 13.2156 8.08442C13.0719 7.94067 13 7.76255 13 7.55005C13 7.33755 13.0719 7.15942 13.2156 7.01567C13.3594 6.87192 13.5375 6.80005 13.75 6.80005C13.9625 6.80005 14.1406 6.87192 14.2844 7.01567C14.4281 7.15942 14.5 7.33755 14.5 7.55005C14.5 7.76255 14.4281 7.94067 14.2844 8.08442Z"
      fill="#ffffff"
    />
    <path
      d="M14.2844 10.0844C14.1406 10.2282 13.9625 10.3 13.75 10.3C13.5375 10.3 13.3594 10.2282 13.2156 10.0844C13.0719 9.94067 13 9.76255 13 9.55005C13 9.33755 13.0719 9.15942 13.2156 9.01567C13.3594 8.87192 13.5375 8.80005 13.75 8.80005C13.9625 8.80005 14.1406 8.87192 14.2844 9.01567C14.4281 9.15942 14.5 9.33755 14.5 9.55005C14.5 9.76255 14.4281 9.94067 14.2844 10.0844Z"
      fill="#ffffff"
    />
    <path
      d="M14.2844 12.0844C14.1406 12.2282 13.9625 12.3 13.75 12.3C13.5375 12.3 13.3594 12.2282 13.2156 12.0844C13.0719 11.9407 13 11.7625 13 11.55C13 11.3375 13.0719 11.1594 13.2156 11.0157C13.3594 10.8719 13.5375 10.8 13.75 10.8C13.9625 10.8 14.1406 10.8719 14.2844 11.0157C14.4281 11.1594 14.5 11.3375 14.5 11.55C14.5 11.7625 14.4281 11.9407 14.2844 12.0844Z"
      fill="#ffffff"
    />
    <rect x="4.5" y="6.80005" width="7.6" height="5.5" rx="1" fill="#ffffff" />
  </SvgIcon>
);
